import {silver} from '~libSass/base/_exports.sass';

export const getBackgroundStyles = ({
  isPremium,
  premiumFeaturesPristine,
  shouldTogglePremiumBackground,
  backgroundColor,
  bkgColor,
  selectedBackground,
}) => {
  const style = {};
  const backgroundIsImage = selectedBackground?.src && !selectedBackground?.isVideo;

  if (isPremium || !premiumFeaturesPristine || shouldTogglePremiumBackground) {
    style.backgroundColor = (!!backgroundColor && bkgColor) || silver;
    if (backgroundIsImage) {
      style.backgroundImage = `url(${selectedBackground?.src})`;
      style.backgroundSize = 'cover';
    }
  } else {
    style.backgroundColor = silver;
  }

  return style;
};
